<div class="app_header-and-footer footer-comp_container">
  <router-link to="/privacy-policy">Privacy and Cookie Policy</router-link>
  <span>{{yearDisplay}}</span>
  <a href="https://jonlervold.com">jonlervold.com</a>
</div>
